// extracted by mini-css-extract-plugin
export default {"cls_1":"Know_cls_1__X6kZm"};